import { TranslationObject } from '../../../i18n/translation';

const namespace = 'praksisstedsection';
const translations: TranslationObject = {
  cancel: {
    id: `${namespace}.cancel`,
    nb: 'Avbryt',
    en: 'Cancel',
  },
  addSted: {
    id: `${namespace}.addSted`,
    nb: 'Legg til praksissted',
    en: 'Add practice place',
  },
  editSted: {
    id: `${namespace}.editSted`,
    nb: 'Endre',
    en: 'Edit',
  },
  removeSted: {
    id: `${namespace}.removeSted`,
    nb: 'Slett',
    en: 'Remove',
  },
  showSted: {
    id: `${namespace}.showSted`,
    nb: 'Vis praksissted',
    en: 'Show',
  },
  stedHeader: {
    id: `${namespace}.placeHeader`,
    nb: 'Praksissted',
    en: 'Practice place',
  },
  avdelingHeader: {
    id: `${namespace}.avdelingHeader`,
    nb: 'Avdeling',
    en: 'Department',
  },
  signatarHeader: {
    id: `${namespace}.signatarHeader`,
    nb: 'Signatar',
    en: 'Signatory',
  },
  handlingHeader: {
    id: `${namespace}.handlingHeader`,
    nb: 'Handling',
    en: 'Action',
  },
  modalTitle: {
    id: `${namespace}.modalTitle`,
    nb: 'Legg til et praksissted i samarbeidsavtalen',
    en: 'Add a practice place to the agreement',
  },
  modalSubtitle: {
    id: `${namespace}.modalSubtitle`,
    nb: 'Plasser samarbeidsavtalen på riktig nivå. Undernivåer kan velges spesifikt. De øverste markerte stedene vil regnes som egne bestillingspunkter.',
    en: 'Find the correct level and place the agreement. Sub-levels may be chosen specifically. The top marked sub-levels will be counted as being specific order points', // TODO - sjekk oversettelse
  },
  modalSubtitleView: {
    id: `${namespace}.modalSubtitleView`,
    nb: 'Informasjon om et praksissted som er med i avtalen. Undernivåer kan være valgt spesifikt. De øverste markerte stedene regnes som egne bestillingspunkter.',
    en: 'Information regarding a practice place included in the agreement. Sub-levels may have been chosen specifically. The top marked sub-levels are be counted as being specific order points.', // TODO - sjekk oversettelse
  },
  modalStedField: {
    id: `${namespace}.modalStedField`,
    nb: 'Søk etter praksissteder v.h.a. navn eller organisasjonsnummer',
    en: 'Search for practice places by name or organization number',
  },
  modalStedFieldView: {
    id: `${namespace}.modalStedFieldView`,
    nb: 'Øverste nivå i praksisstedhierarkiet til avtalestedet',
    en: 'The top node of the included practice place in the agreement',
  },
  modalStedFieldPlaceholder: {
    id: `${namespace}.modalStedFieldPlaceholder`,
    nb: 'Navn eller organisasjonsnummer',
    en: 'Name or organization number',
  },
  modalStedFieldNoResults: {
    id: `${namespace}.modalStedFieldNoResults`,
    nb: 'Ingen registrerte praksissteder i Arbeidslivsportalen stemmer overens med søket.',
    en: 'No practice places registered in Arbeidslivsportalen matches the given search.',
  },
  modalStedChoose: {
    id: `${namespace}.modalStedChoose`,
    nb: 'Velg avtalestedet som skal omfattes av avtalen',
    en: 'Choose the top node in the practice place hierarchy',
  },
  modalStedChosenView: {
    id: `${namespace}.modalStedChosenView`,
    nb: 'Avtalestedet som omfattes av avtalen',
    en: 'The practice place included in the agreement',
  },
  modalStedChoosePlaceholder: {
    id: `${namespace}.modalStedChoosePlaceholder`,
    nb: 'Søk etter praksissted, og/eller velg fra menyen under.',
    en: 'Search for the top node and/or find it in the menu below.', // TODO Noen må finne ut av hva disse greiene skal hete på engelsk
  },
  modalStedHeader: {
    id: `${namespace}.modalStedHeader`,
    nb: 'Praksissted',
    en: 'Practice place',
  },
  modalStatusHeader: {
    id: `${namespace}.modalStatusHeader`,
    nb: 'Status',
    en: 'Status',
  },
  modalHandlingHeader: {
    id: `${namespace}.modalHandlingHeader`,
    nb: 'Handling',
    en: 'Action',
  },
  modalNotOmfattetSteder: {
    id: `${namespace}.modalNotOmfattetSteder`,
    nb: 'Ingen spesifikke praksissteder er huket av. Det betyr at avtalestedet vil være eneste mulig bestillingspunkt, og at alle praksisstedene under er med i avtalen. Fremtidige endringer i hierarkiet, under avtalested, vil automatisk inkluderes i avtalen.',
    en: "No specific practice places have been ticked, which means that the top level will be the only possible point of order, and that all practice places below it are included in the agreement. Future changes in the hierarchy below the agreement's practice place will automatically be included.",
  },
  modalOmfattetSteder: {
    id: `${namespace}.modalOmfattetSteder`,
    nb: 'Det er huket av spesifikke praksissteder. Dette betyr at kun avtalestedet, samt praksisstedene som er huket av, inkluderes som bestillingspunkter i avtalen. Mellomnivåer og eventuelle undernoder av spesifikke praksissteder i hierarkiet inkluderes også i avtalen, men ikke som egne, mulige bestillingspunkter.',
    en: 'Specific practice place(s) have been ticked, which means that the agreement only includes these given practice places, as well as the top level, as specific practice places in the agreement. Middle levels and potential child nodes of specific practice places are also included in the agreement, but not as specific points of order.',
  },
  signeringTitle: {
    id: `${namespace}.signeringTitle`,
    nb: 'Signering',
    en: 'Signing',
  },
  signeringSubtitle: {
    id: `${namespace}.signeringSubtitle`,
    nb: 'Skriv inn kontaktinformasjon for personen som har ansvaret for å signere avtalen for avtalestedet/praksisstedene. Signeringen foregår ved hjelp av postens signeringsløsning.',
    en: 'Fill inn contact information for the person responsible for signing the agreement. The signing process is done through Posten Norge.',
  },
  fornavnLabel: {
    id: `${namespace}.fornavnLabel`,
    nb: 'Fornavn',
    en: 'First name',
  },
  etternavnLabel: {
    id: `${namespace}.etternavnLabel`,
    nb: 'Etternavn',
    en: 'Surname',
  },
  epostLabel: {
    id: `${namespace}.epostLabel`,
    nb: 'Epostadresse',
    en: 'E-mail address',
  },
  tlfLabel: {
    id: `${namespace}.tlfLabel`,
    nb: 'Telefonnummer',
    en: 'Phone number',
  },
  // RowStatus labels
  AKTIV_BESTILLINGSPUNKT: {
    id: `${namespace}.AKTIV_BESTILLINGSPUNKT`,
    nb: 'Aktivt bestillingspunkt i avtalen',
    en: 'Active point of order in the agreement',
  },
  AKTIV_IKKE_BESTILLINGSPUNKT: {
    id: `${namespace}.AKTIV_IKKE_BESTILLINGSPUNKT`,
    nb: 'Aktivt, men er ikke et eget bestillingspunkt i avtalen',
    en: 'Active, but is not a point of order in the agreement',
  },
  INAKTIV_IKKE_MED_I_AVTALE: {
    id: `${namespace}.INAKTIV_IKKE_MED_I_AVTALE`,
    nb: 'Er ikke inkludert i avtalen',
    en: 'Is not included in the agreement',
  },
  UGYLDIG_BESTILLINGSPUNKTER_I_HIERARKI: {
    id: `${namespace}.UGYLDIG_BESTILLINGSPUNKTER_I_HIERARKI`,
    nb: 'Ugyldig tilstand. Et bestillingspunkt kan ikke ha andre bestillingspunkter under/over seg.',
    en: 'Invalid state. A point of order cannot have other points of order under/above it self.',
  },
};

export default translations;
